import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { Layout } from 'layouts';
import { Error } from 'components';
import { useAnalytics } from 'hooks';

export const ScreensError = (props) => {
  const analytics = useAnalytics();

  useEffect(() => {
    analytics.screenViewedError(props.errorMessage);
  }, [analytics, props.errorMessage]);

  return (
    <Layout showBackButton={false}>
      <Error {...props} />
    </Layout>
  );
};

ScreensError.propTypes = {
  errorMessage: PropTypes.string,
};

export default ScreensError;
